<template>
    <document-page title="Πολιτική απορρήτου" eyebrow="PARON CARD" subtitle="Πώς ο Π.Α.Ρ.Ο.Ν. συλλέγει, χρησιμοποιεί και προστατεύει τα προσωπικά σας δεδομένα.">
                    <h2>Εισαγωγή και σύνοψη</h2>
                    <p>Η προστασία της ιδιωτικότητάς σας είναι σημαντική για τον Π.Α.Ρ.Ο.Ν. Επεξεργαζόμαστε πληροφορίες που σας αφορούν (στο εξής «Δεδομένα») πάντα με σεβασμό στα δικαιώματά σας και στη σχετική νομοθεσία της Ευρωπαϊκής Ένωσης. Με την παρούσα πολιτική θέλουμε να σας ενημερώσουμε για τον τρόπο με τον οποίο επεξεργαζόμαστε τα προσωπικά σας δεδομένα και για τα δικαιώματά σας. Η πολιτική αυτή εξηγεί επίσης πώς επεξεργαζόμαστε τα Δεδομένα που έχουμε στη διάθεσή μας από οποιαδήποτε επικοινωνία, σχέση ή συναλλαγή μαζί σας, καθώς και για οποιονδήποτε άλλο λόγο. Προσωπικά δεδομένα είναι κάθε πληροφορία που μπορεί να συνδεθεί με εσάς ως φυσικό πρόσωπο, για παράδειγμα το ονοματεπώνυμο και τα στοιχεία επικοινωνίας σας.</p>
                    <p>Συνοπτικά, επεξεργαζόμαστε τα δεδομένα σας για τους εξής λόγους:</p>
                    <ul>
                    <li>Στον βαθμό που είναι απαραίτητο για την παροχή των υπηρεσιών μας προς εσάς.</li>
                    <li>Για να σας ενημερώνουμε για προσφορές και νέα, μέσω newsletter, μηνυμάτων κειμένου (SMS) και στοχευμένης προβολής στα μέσα κοινωνικής δικτύωσης και σε άλλα μέσα, διαδικτυακά και μη.</li>
                    <li>Για να επικοινωνούμε μαζί σας και να απαντάμε στις ερωτήσεις σας.</li>
                    <li>Για να σας ρωτάμε για τον Π.Α.Ρ.Ο.Ν. και την εμπειρία σας από εμάς.</li>
                    <li>Για να σας ενημερώνουμε για αλλαγές στις υπηρεσίες μας.</li>
                    <li>Για τη δημιουργία και τη διατήρηση του λογαριασμού σας (συμπεριλαμβανομένων λειτουργιών όπως τα αγαπημένα).</li>
                    <li>Για τη συμμόρφωσή μας με την ισχύουσα νομοθεσία (π.χ. τη φορολογική και λογιστική νομοθεσία).</li>
                    </ul>
                    <p>Σύμφωνα με τη νομοθεσία για την προστασία των δεδομένων έχετε διάφορα δικαιώματα. Για παράδειγμα, έχετε πάντα το δικαίωμα να αντιταχθείτε στη χρήση των δεδομένων σας για σκοπούς προώθησης (marketing).</p>
                    <p>Θέλετε να μάθετε περισσότερα; Παρακάτω θα βρείτε αναλυτικά <em>πώς</em>, <em>γιατί και για πόσο χρονικό διάστημα επεξεργαζόμαστε τα προσωπικά σας δεδομένα</em>.</p>
                    <h2>Πώς συλλέγουμε τα δεδομένα</h2>
                    <p>Συλλέγουμε πληροφορίες με διάφορους τρόπους μέσω της ιστοσελίδας και της εφαρμογής, όπως:</p>
                    <ul>
                    <li>Κατά την εγγραφή και τη δημιουργία λογαριασμού</li>
                    <li>Μέσω της κάμερας, κατά τη σάρωση αποδείξεων</li>
                    <li>Μέσω cookies και άλλων παρόμοιων τεχνολογιών</li>
                    </ul>
                    <h2>Ποια δεδομένα συλλέγουμε</h2>
                    <p>Συλλέγουμε τα ακόλουθα Δεδομένα:</p>
                    <p>Τα προσωπικά σας στοιχεία που μας αποστέλλετε κατά τη διαδικασία της εγγραφής.</p>
                    <p>Πληροφορίες σχετικά με τη διεύθυνση πρωτοκόλλου διαδικτύου (διεύθυνση IP), την ώρα πρόσβασής σας στην ιστοσελίδα, τη διεύθυνση URL, καθώς και τον τύπο και τις ρυθμίσεις του προγράμματος περιήγησής σας. Επίσης, πληροφορίες για τις πρόσφατες επισκέψεις σας στην ιστοσελίδα μας και για το περιεχόμενο που είδατε κατά την επίσκεψή σας. Τις πληροφορίες αυτές τις συλλέγουμε μέσω των cookies και των άλλων τεχνολογιών που χρησιμοποιούμε, μόνο με τη συγκατάθεσή σας, εκτός αν είναι απαραίτητες για την περιήγησή σας στην ιστοσελίδα. Οι πληροφορίες αυτές είναι ανώνυμες και δεν μπορούμε να σας ταυτοποιήσουμε μέσω αυτών.</p>
                    <h2>Για ποιον λόγο τα επεξεργαζόμαστε</h2>
                    <p>Επεξεργαζόμαστε τα Δεδομένα αυτά μόνο όταν είναι απαραίτητο για:</p>
                    <ul>
                    <li>Τη διεκπεραίωση του αιτήματός σας και την ανάληψη των κατάλληλων ενεργειών, ώστε να έχουμε την καλύτερη δυνατή σχέση μαζί σας και να βελτιώνουμε τις υπηρεσίες μας.</li>
                    <li>Την κατανόηση του τρόπου με τον οποίο χρησιμοποιείτε την ιστοσελίδα μας, ώστε να την κάνουμε πιο λειτουργική και ασφαλή.</li>
                    </ul>
                    <p>Σε ορισμένες περιπτώσεις μπορεί να χρειαστεί να χρησιμοποιήσουμε τα Δεδομένα για:</p>
                    <ul>
                    <li>Τη συμμόρφωσή μας με τις νόμιμες υποχρεώσεις μας.</li>
                    </ul>
                    <h2>Για πόσο χρονικό διάστημα τα διατηρούμε</h2>
                    <p>Επεξεργαζόμαστε τα Δεδομένα μόνο για όσο διάστημα είναι απαραίτητο για την εκπλήρωση των σκοπών για τους οποίους τα συλλέξαμε. Ελέγχουμε περιοδικά τα Δεδομένα που έχουμε αποθηκεύσει και τα διαγράφουμε όταν δεν είναι πλέον απαραίτητα για τους σκοπούς αυτούς. Ειδικότερα:</p>
                    <ul>
                    <li>Διατηρούμε τις πληροφορίες που αφορούν τα αιτήματά σας για όσο χρόνο απαιτείται για την εξέτασή τους και την ανάληψη των κατάλληλων ενεργειών.</li>
                    <li>Διατηρούμε τις πληροφορίες που συλλέγουμε μέσω cookies και αρχείων καταγραφής (logs) σύμφωνα με την Πολιτική για τα cookies και τις άλλες τεχνολογίες.</li>
                    </ul>
                    <h2>Ασφάλεια</h2>
                    <p>Λαμβάνουμε τα κατάλληλα τεχνικά και οργανωτικά μέτρα για την ασφαλή επεξεργασία των Δεδομένων, ώστε να αποτρέπεται η μη εξουσιοδοτημένη πρόσβαση, αλλοίωση ή κοινοποίησή τους.</p>
                    <h2>Υπεύθυνος προστασίας δεδομένων</h2>
                    <p>Για οποιαδήποτε ερώτηση σχετικά με την επεξεργασία των δεδομένων σας, μπορείτε να επικοινωνήσετε με τον υπεύθυνο επεξεργασίας στο <a href="mailto:contact@paron-card.gr">contact@paron-card.gr</a>, με έδρα τη Λεωφόρο Αμφιθέας 167 &amp; Μετσόβου 2, Παλαιό Φάληρο, Αθήνα. Μπορείτε επίσης να επικοινωνήσετε με τον Υπεύθυνο Προστασίας Δεδομένων (DPO) στο <a href="mailto:contact@paron-card.gr">contact@paron-card.gr</a>.</p>
                    <h2>Τα δικαιώματά σας για την επεξεργασία των προσωπικών σας δεδομένων</h2>
                    <p>Σύμφωνα με τη νομοθεσία για την προστασία των δεδομένων, έχετε μια σειρά από δικαιώματα σχετικά με την επεξεργασία των προσωπικών σας δεδομένων από εμάς. Διαβάστε περισσότερα παρακάτω.</p>
                    <p>Από τη στιγμή που συλλέγουμε τις πληροφορίες σας, σεβόμαστε πλήρως τα δικαιώματα που διατηρείτε σε σχέση με αυτές. Τα δικαιώματα αυτά ορίζονται από τον Γενικό Κανονισμό για την Προστασία Δεδομένων (ΓΚΠΔ - GDPR) και παρατίθενται παρακάτω για την ενημέρωσή σας.</p>
                    <p><strong>Με την επιφύλαξη ορισμένων περιορισμών σε κάποια από αυτά, έχετε τα ακόλουθα δικαιώματα σε σχέση με τις πληροφορίες σας:</strong></p>
                    <ul>
                    <li><strong>Δικαίωμα ενημέρωσης</strong> - έχετε το δικαίωμα να λάβετε επιβεβαίωση για το αν επεξεργαζόμαστε ή όχι προσωπικά δεδομένα που σας αφορούν και να ζητήσετε αντίγραφο των πληροφοριών που τηρούμε για εσάς.</li>
                    <li><strong>Δικαίωμα πρόσβασης</strong> - έχετε το δικαίωμα πρόσβασης στα προσωπικά δεδομένα σας που τηρούμε.</li>
                    <li><strong>Δικαίωμα διόρθωσης</strong> - έχετε το δικαίωμα να ζητήσετε τη διόρθωση ανακριβών προσωπικών δεδομένων ή τη συμπλήρωσή τους, εφόσον είναι ελλιπή.</li>
                    <li><strong>Δικαίωμα διαγραφής, γνωστό και ως «δικαίωμα στη λήθη»</strong> - υπό ορισμένες προϋποθέσεις, έχετε το δικαίωμα να ζητήσετε τη διαγραφή των προσωπικών σας δεδομένων. Αυτό ισχύει, για παράδειγμα, όταν τα δεδομένα δεν είναι πλέον απαραίτητα για τους σκοπούς για τους οποίους συλλέχθηκαν ή υποβλήθηκαν σε επεξεργασία, ή όταν ανακαλείτε τη συγκατάθεση στην οποία βασίζεται η επεξεργασία και δεν υπάρχει άλλη νόμιμη βάση για τη συνέχισή της.</li>
                    <li><strong>Δικαίωμα περιορισμού της επεξεργασίας</strong> - έχετε το δικαίωμα να ζητήσετε τον περιορισμό της επεξεργασίας των προσωπικών σας δεδομένων. Αυτό ισχύει, για παράδειγμα, όταν αμφισβητείτε την ακρίβεια των δεδομένων ή όταν η επεξεργασία είναι παράνομη και, αντί για τη διαγραφή των δεδομένων, ζητάτε τον περιορισμό της χρήσης τους.</li>
                    <li>
                        <strong>Δικαίωμα στη φορητότητα των δεδομένων</strong> - έχετε το δικαίωμα να μας ζητήσετε να διαβιβάσουμε ορισμένα από τα προσωπικά δεδομένα που τηρούμε για εσάς σε άλλη εταιρεία και να τα επαναχρησιμοποιήσετε για δικούς σας σκοπούς σε διαφορετικές υπηρεσίες. Το δικαίωμα αυτό αφορά τα προσωπικά δεδομένα που μας έχετε παράσχει, σε δομημένο, κοινώς χρησιμοποιούμενο, αναγνώσιμο από μηχανήματα και διαλειτουργικό μορφότυπο, εφόσον:
                        <ul>
                        <li>η επεξεργασία βασίζεται σε συγκατάθεση ή σε σύμβαση και</li>
                        <li>η επεξεργασία διενεργείται με αυτοματοποιημένα μέσα.</li>
                        </ul>
                        Κατά την άσκηση του δικαιώματος αυτού, έχετε το δικαίωμα να ζητήσετε την απευθείας διαβίβαση των δεδομένων σας από τον Π.Α.Ρ.Ο.Ν. σε άλλον υπεύθυνο επεξεργασίας, όπου αυτό είναι τεχνικά εφικτό.
                    </li>
                    <li><strong>Δικαίωμα εναντίωσης</strong> - έχετε το δικαίωμα να ανακαλέσετε, εν όλω ή εν μέρει, τη συγκατάθεση που έχετε δώσει για την επεξεργασία των προσωπικών σας δεδομένων. Η ανάκληση ισχύει από τη στιγμή που τη γνωστοποιείτε. Έχετε επίσης το δικαίωμα να αντιταχθείτε στην επεξεργασία των προσωπικών σας δεδομένων από εμάς και, σε κάθε περίπτωση, το δικαίωμα να αρνηθείτε την αποστολή προωθητικού υλικού, όπως τα newsletter.</li>
                    <li><strong>Δικαιώματα σχετικά με την αυτοματοποιημένη λήψη αποφάσεων και την κατάρτιση προφίλ</strong> - έχετε το δικαίωμα να μην υπόκεισθε σε απόφαση που λαμβάνεται αποκλειστικά βάσει αυτοματοποιημένης επεξεργασίας, συμπεριλαμβανομένης της κατάρτισης προφίλ.</li>
                    <li><strong>Δικαίωμα υποβολής καταγγελίας σε εποπτική αρχή</strong> - αν θεωρείτε ότι τα δικαιώματά σας παραβιάζονται με οποιονδήποτε τρόπο, έχετε το δικαίωμα να υποβάλετε καταγγελία σε εποπτική αρχή, ιδίως στο κράτος μέλος της ΕΕ/ΕΟΧ όπου έχετε τη συνήθη διαμονή σας, τον τόπο εργασίας σας ή όπου σημειώθηκε η εικαζόμενη παραβίαση της νομοθεσίας για την προστασία των δεδομένων. Στην Ελλάδα, εποπτική αρχή είναι η Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα. Το δικαίωμα αυτό ισχύει με την επιφύλαξη κάθε άλλης διοικητικής ή δικαστικής προσφυγής.</li>
                    <li><strong>Επιβεβαίωση ταυτότητας:</strong> σε περίπτωση αμφιβολίας, ενδέχεται να ζητήσουμε πρόσθετες πληροφορίες για την επιβεβαίωση της ταυτότητάς σας. Αυτό γίνεται για την προστασία των δικαιωμάτων και της ιδιωτικότητάς σας.</li>
                    <li><strong>Καταχρηστική άσκηση δικαιωμάτων:</strong> αν ασκείτε κάποιο από τα δικαιώματα αυτά υπερβολικά συχνά και με προφανή πρόθεση κατάχρησης, ενδέχεται να σας χρεώσουμε ένα διοικητικό τέλος ή να αρνηθούμε να εξετάσουμε το αίτημά σας.</li>
                    </ul>
                    <h2>Αλλαγές στην πολιτική απορρήτου</h2>
                    <p>Ο Π.Α.Ρ.Ο.Ν. διατηρεί το δικαίωμα να τροποποιεί ή να συμπληρώνει την παρούσα Πολιτική απορρήτου οποτεδήποτε και για οποιονδήποτε λόγο, στο πλαίσιο που επιτρέπει η ισχύουσα νομοθεσία. Σε περίπτωση ουσιωδών αλλαγών, η Πολιτική θα ενημερώνεται σε αυτή τη σελίδα. Για τον λόγο αυτό σας συνιστούμε να ελέγχετε τακτικά το περιεχόμενό της.</p>
                    <p>Η παρούσα πολιτική απορρήτου υιοθετήθηκε από τον Π.Α.Ρ.Ο.Ν. τον Μάιο του 2023.</p>

        <template #after>
            <section class="unsubscribe">
                <h2>Διαγραφή από το newsletter</h2>
                <p>Για να σταματήσετε να λαμβάνετε τα newsletter και τα υπόλοιπα ενημερωτικά μας email, πληκτρολογήστε το email σας και πατήστε «Διαγραφή».</p>
                <v-alert v-if="unsubscribed === true" type="success" text dense class="mb-0">
                    Διαγραφήκατε επιτυχώς από τη λίστα newsletter
                </v-alert>
                <template v-else>
                    <v-form class="unsubscribe__form" @submit.prevent="confirm = true">
                        <v-text-field
                            v-model="email"
                            type="email"
                            label="Email"
                            outlined
                            dense
                            hide-details
                            clearable
                            prepend-inner-icon="mdi-email-outline"
                        />
                        <v-btn type="submit" color="#1b2f5a" :dark="!!email" depressed large :disabled="!email">
                            Διαγραφή
                        </v-btn>
                    </v-form>
                    <v-alert v-if="unsubscribed === false" type="error" text dense class="mt-4 mb-0">
                        Κάτι πήγε στραβά. Παρακαλούμε επικοινωνήστε μαζί μας στο contact@paron-card.gr
                    </v-alert>
                </template>
                <v-dialog v-model="confirm" max-width="380">
                    <v-card class="pa-2">
                        <v-card-title class="text-h6">Είστε σίγουροι;</v-card-title>
                        <v-card-text>Δεν θα λαμβάνετε πλέον newsletter στο {{ email }}.</v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn text @click="confirm = false">Ακύρωση</v-btn>
                            <v-btn color="#ad282d" dark depressed :loading="loading" @click="unsubscribe">Διαγραφή</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </section>
        </template>
    </document-page>
</template>
  
  
  <script>
    import restApi from "@/rest-api"
    import DocumentPage from '@/components/DocumentPage.vue'

    export default {
      components: { DocumentPage },
      data() {
          return {
            email: '',
            unsubscribed: null,
            confirm: false,
            loading: false
          }
      },
      methods: {
        unsubscribe() {
            this.loading = true
            restApi
            .post(`/member/unsubscribe`, {'email': this.email})
            .then(() => {
                this.unsubscribed = true
            })
            .catch((error) => {
                this.unsubscribed = false
                console.log(error)
            })
            .finally(() => {
                this.loading = false
                this.confirm = false
            })
        }
      }
    }
  </script>
  
  <style lang="scss" scoped>
    .unsubscribe {
        margin-top: 24px;
        padding: 28px 32px;
        background: #f2f4f8;
        border-radius: 18px;
        color: #1b2f5a;
    }

    .unsubscribe h2 {
        margin: 0 0 6px;
        font-size: 20px;
        font-weight: 700;
    }

    .unsubscribe p {
        margin: 0 0 16px;
        font-size: 15px;
    }

    .unsubscribe__form {
        display: flex;
        gap: 12px;
        align-items: center;
        max-width: 560px;
    }

    .unsubscribe__form .v-text-field {
        background: #fff;
    }

    @media (max-width: 599px) {
        .unsubscribe {
            padding: 22px 20px;
        }

        .unsubscribe__form {
            flex-direction: column;
            align-items: stretch;
        }
    }
</style>